module.exports = __webpack_public_path__ + "static/favicons/apple-touch-icon-152x152-1e29ffc77dd9ac75b60f58670696d6dc.png";